module.exports = __WEBPACK_EXTERNAL_MODULE__1823__;